import { Search, Close } from '@mui/icons-material';
import { Grid, TextField, InputAdornment } from '@mui/material';
import React, { ChangeEvent, FC } from 'react';
import { useCertificates } from '../../hooks/useCertificates';

interface Props {
  onSearch: (search: string) => void;
}

export const CertificateSearch: FC<Props> = ({ onSearch }) => {
  const { search, setSearch } = useCertificates();

  const handleCertificateSearchChange = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setSearch(value);
    onSearch(value);
  };

  const filterCleaning = () => {
    if (search === '') {
      return;
    }
    setSearch('');
    onSearch('');
  };

  return (
    <Grid item xs={12} md={6}>
      <TextField
        label="Buscar"
        variant="outlined"
        fullWidth
        size={'small'}
        value={search}
        sx={{ py: 1 }}
        onChange={handleCertificateSearchChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end" style={{ cursor: 'pointer' }}>
              <Close onClick={filterCleaning} />
            </InputAdornment>
          ),
        }}
      />
    </Grid>
  );
};
